import React from 'react';

import { LargeForecastCardContainer } from '../../../styles';
import { CardBodyLoadingUI } from './cardBodyLoadingUI';
import { CardTitleLoadingUI } from './cardTitleLoadingUI';

export const LargeHourCardItemLoadingUI = () => {
    return (
        <LargeForecastCardContainer>
            <CardTitleLoadingUI />
            <CardBodyLoadingUI />
        </LargeForecastCardContainer>
    );
};
